.badge {
  --badge-bg: var(--color-neutral-bg);
  --badge-fg: var(--color-neutral-fg);
  --badge-border: var(--color-neutral-border);

  display: inline-flex;
  align-items: center;
  gap: var(--space-1-5);
  max-width: 100%;
  border: 1px solid var(--badge-border);
  border-radius: var(--radius-full);
  background-color: var(--badge-bg);
  color: var(--badge-fg);
  font-weight: var(--font-weight-semibold);
  line-height: 1.2;
  white-space: nowrap;
  vertical-align: middle;
}

.md {
  padding: 0.1875rem var(--space-2-5);
  font-size: var(--font-size-xs);
}

.sm {
  padding: 0.0625rem var(--space-2);
  font-size: 0.6875rem;
}

.info {
  --badge-bg: var(--color-info-bg);
  --badge-fg: var(--color-info-fg);
  --badge-border: var(--color-info-border);
}

.success {
  --badge-bg: var(--color-success-bg);
  --badge-fg: var(--color-success-fg);
  --badge-border: var(--color-success-border);
}

.warning {
  --badge-bg: var(--color-warning-bg);
  --badge-fg: var(--color-warning-fg);
  --badge-border: var(--color-warning-border);
}

.danger {
  --badge-bg: var(--color-danger-bg);
  --badge-fg: var(--color-danger-fg);
  --badge-border: var(--color-danger-border);
}

.special {
  --badge-bg: var(--color-special-bg);
  --badge-fg: var(--color-special-fg);
  --badge-border: var(--color-special-border);
}

.accent {
  --badge-bg: var(--color-accent-bg);
  --badge-fg: var(--color-accent-fg);
  --badge-border: var(--color-accent-border);
}

.dot {
  width: 0.4375rem;
  height: 0.4375rem;
  border-radius: 50%;
  background-color: currentColor;
  flex-shrink: 0;
}

.icon {
  display: inline-flex;
}

.icon > svg {
  width: 0.875rem;
  height: 0.875rem;
}
